import React, {useMemo, useState} from "react"
import {useFormik} from "formik"
import * as Yup from "yup"
import moment from "moment"
import {ToastContainer} from "react-toastify"

import notifyToast from "../../components/Toast/Toast"
import {naloziIzvjestaj} from "../../api/fmkNalozi"
import TitleComponent from "../../components/TitleComponent/TitleComponent"

import "moment/locale/bs"

moment.locale("bs")

/* ================= HELPERS ================= */

const formatDate = (d?: string) =>
    d ? moment(d).format("DD.MM.YYYY HH:mm") : "—"

/* ================= COMPONENT ================= */

const FMKNalogIzvjestaj: React.FC = () => {

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<any>(null)
    const [zoomImg, setZoomImg] = useState<string | null>(null)

    /* ================= FORM ================= */

    const formik = useFormik({
        initialValues: {brojNaloga: ""},
        validationSchema: Yup.object({
            brojNaloga: Yup.string().required()
        }),
        onSubmit: async (values) => {

            setLoading(true)

            try {
                const res: any = await naloziIzvjestaj(values)
                setData(res.data)
            } catch (e: any) {
                notifyToast(false, e?.response?.data?.message)
            } finally {
                setLoading(false)
            }
        }
    })

    return (
        <div className="card shadow-sm">

            <ToastContainer/>

            <div className="card-header mt-10">
                <TitleComponent name="📄 Izvještaj naloga"/>
            </div>

            <div className="card-body">

                {/* ================= SEARCH ================= */}

                {!data && (
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <input
                                    className="form-control form-control-lg"
                                    placeholder="Broj naloga"
                                    {...formik.getFieldProps("brojNaloga")}
                                />
                            </div>

                            <div className="col-md-2">
                                <button
                                    className="btn btn-primary w-100"
                                    disabled={loading}
                                >
                                    {loading ? "Učitavanje..." : "Prikaži"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}

                {/* ================= REPORT ================= */}

                {data && (

                    <div className="d-flex flex-column gap-7 mt-5">

                        {/* ================= FMK INFO ================= */}
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className="card shadow-sm">

                                    <div className="card-header">
                                        <h4 className='mt-6'>📄 {data.fmkNalog?.brojNaloga}</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">

                                            <div className="col-12">
                                                <div className="border rounded p-3 h-100">
                                                    <div className="text-muted small">Kupac</div>
                                                    <div className="fs-4 fw-bold">
                                                        {data.fmkNalog?.Kupac}
                                                    </div>

                                                    📍 {data.fmkNalog?.KupacAdresa}<br/>
                                                    {data.fmkNalog?.KupacPTT} {data.fmkNalog?.KupacGrad}<br/>
                                                    ☎ {data.fmkNalog?.KupacTelefon}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="border rounded p-3 h-100">

                                                    <div className="text-muted small">
                                                        Rok isporuke
                                                    </div>

                                                    <div className="fs-3 fw-bold text-danger">
                                                        {formatDate(data.fmkNalog?.rokIsporuke)}
                                                    </div>

                                                    <hr/>

                                                    <b>Komercijalista</b><br/>
                                                    {data.fmkNalog?.korisnik}
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="border rounded p-3 h-100">

                                                    <div className="text-muted small">
                                                        Napomena
                                                    </div>

                                                    {data.fmkNalog?.napomena || "—"}

                                                    <hr/>

                                                    Datum dokumenta<br/>
                                                    {formatDate(data.fmkNalog?.datumDokumenta)}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className="card shadow-sm">
                                    <div className="card-header">
                                        <h4 className='mt-6'>📦 Stavke naloga {data.fmkNalog?.brojNaloga}</h4>
                                    </div>

                                    <div className="card-body table-responsive">

                                        {!data.fmkStavke?.length &&
                                            <div className="text-muted">
                                                Nema stavki.
                                            </div>
                                        }

                                        <table className="table table-hover">
                                            <thead className="table-light">
                                            <tr>
                                                <th>Šifra</th>
                                                <th>Naziv</th>
                                                <th className="text-end">Količina</th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            {data.fmkStavke?.map((s: any) => (
                                                <tr key={s.id}>
                                                    <td className="fw-bold">
                                                        {s.idArtikla}
                                                    </td>
                                                    <td>{s.Naziv}</td>
                                                    <td className="text-end">
                                                <span className="badge bg-light fs-8">
                                                    {s.kolicina}
                                                </span>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <div className="card shadow-sm">
                                    <div className="card-header">
                                        <h4 className='mt-6'>🚛 Utovar | Zabiljeske utovara</h4>
                                    </div>

                                    <div className="card-body row g-4">

                                        {data.transportNalozi?.map((t: any) => {

                                            const duration =
                                                moment(t.krajUtovara)
                                                    .diff(moment(t.startUtovara), 'seconds')

                                            return (
                                                <div className="col-md-6" key={t.Id}>
                                                    <div className="border rounded p-4 bg-light">

                                                        <div className='row'>
                                                            <div className='col-6'>
                                                                <div>
                                                                    Početak:<br/>
                                                                    {formatDate(t.startUtovara)}
                                                                </div>
                                                            </div>
                                                            <div className='col-6'>
                                                                <div>
                                                                    Kraj:<br/>
                                                                    {formatDate(t.krajUtovara)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr/>
                                                        <div>
                                                            Uposlenik:<br/>
                                                            {t.uposlenik?.UposlenikImePrezime}
                                                        </div>
                                                        <hr/>

                                                        <div className="fs-3 fw-bold text-primary">
                                                            ⏱ {duration}s
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className="card shadow-sm">

                                    <div className="card-header">
                                        <h4 className='mt-6'>📸 Fotografije utovara</h4>
                                    </div>

                                    <div className="card-body">

                                        <div className="row g-4">

                                            {data.transportSlike?.map((img: any) => (
                                                <div className="col-lg-3 col-md-4 col-6"
                                                     key={img.Id}>

                                                    <div
                                                        className="card shadow-sm cursor-pointer"
                                                        onClick={() => setZoomImg(img.url)}
                                                    >
                                                        <img
                                                            src={img.url}
                                                            className="card-img-top"
                                                            style={{
                                                                height: 220,
                                                                objectFit: "cover"
                                                            }}
                                                        />

                                                        <div className="card-body p-2 text-center">
                                                            <small>{img.original_name}</small>
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ================= RADNI NALOZI ================= */}

                        <div className="card shadow-sm">

                            <div className="card-header">
                                <h4 className='mt-6'>👷 Proizvodnja</h4>
                            </div>

                            <div className="card-body">

                                {data.radniNalozi?.map((n: any) => (
                                    <div key={n.Id}
                                         className="border rounded p-4 mb-4">

                                        <div className="row mb-3">

                                            <div className="col-md-4">
                                                Početak<br/>
                                                {formatDate(n.Pocetak)}
                                            </div>

                                            <div className="col-md-4">
                                                Kraj<br/>
                                                {formatDate(n.Kraj)}
                                            </div>

                                            <div className="col-md-4">
                                                <span className="badge bg-success">
                                                    Završeno
                                                </span>
                                            </div>

                                        </div>

                                        <table className="table table-sm">
                                            <thead>
                                            <tr>
                                                <th>Artikal</th>
                                                <th>Količina</th>
                                                <th>Uposlenik</th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            {n.stavke.map((s: any) => (
                                                <tr key={s.Id}>
                                                    <td>{s.NazivArtikla}</td>
                                                    <td className="fw-bold">
                                                        {s.Kolicina} {s.Jm}
                                                    </td>
                                                    <td>
                                                        {s.uposlenik?.UposlenikImePrezime}
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>

                                    </div>
                                ))}

                            </div>
                        </div>

                    </div>
                )}

                {/* ================= IMAGE ZOOM ================= */}

                {zoomImg && (
                    <div
                        className="modal fade show d-block"
                        style={{background: "rgba(0,0,0,.85)"}}
                        onClick={() => setZoomImg(null)}
                    >
                        <div className="modal-dialog modal-xl modal-dialog-centered">
                            <img
                                src={zoomImg}
                                style={{width: "100%", borderRadius: 8}}
                            />
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default FMKNalogIzvjestaj